import React from 'react';

import styles from './MainPage.m.sass';

import animateScrollTo from 'animated-scroll-to';

import {connect} from 'react-redux';
import {fetchRootTaxonChildren, fetchTaxonBySlug, fetchTaxonChildrenBySlug, fetchTaxonProductsBySlug, fetchTaxonShowcase} from '../../ducks/taxons';
import {setUiBreadcrumbs, setUiMenuTaxon} from '../../ducks/ui';

import {taxonNestedSet} from '../../utils/taxons';
import memoizeOne from 'memoize-one';

import Hero from "../../components/hero/Hero";
import Button from "../../components/button/Button";
import Services from "../../components/services/Services";
import How from "../../components/how/How";
import Advantages from '../../components/advantages/Advantages';
import Reviews from '../../components/reviews/Reviews';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import Loader from '../../components/loader/Loader';
import Content from '../../components/content/Content';
import {browserHistory} from 'react-router';
import Toggle from '../../components/toggle/Toggle';
import ErrorPage from '../../containers/errorPage/ErrorPage';
import JSONLDWebsite from '../../components/JSON-LD/JSONLDWebsite';


const DEFAULT_MAIN_TAXON = process.env.PRIMARY_TAXON;


@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@connect(({taxons}, {params}) => ({
  mainTaxons: taxons.root.children,
  taxon: taxons.taxon[params.mainTaxonSlug || DEFAULT_MAIN_TAXON],
  menu: taxons.children[params.mainTaxonSlug || DEFAULT_MAIN_TAXON],
  products: taxons.products.all[params.mainTaxonSlug || DEFAULT_MAIN_TAXON],
  showcase: taxons.showcase[params.mainTaxonSlug || DEFAULT_MAIN_TAXON]
}))
export default class MainPage extends React.PureComponent {
  static fetchData = ({dispatch, params, mainTaxons, taxon, menu, products, showcase}) => Promise.all([
    mainTaxons === undefined && dispatch(fetchRootTaxonChildren()),
    taxon === undefined && dispatch(fetchTaxonBySlug(params.mainTaxonSlug || DEFAULT_MAIN_TAXON)),
    menu === undefined && dispatch(fetchTaxonChildrenBySlug(params.mainTaxonSlug || DEFAULT_MAIN_TAXON)),
    products === undefined && dispatch(fetchTaxonProductsBySlug('all', params.mainTaxonSlug || DEFAULT_MAIN_TAXON)),
    showcase === undefined && dispatch(fetchTaxonShowcase(params.mainTaxonSlug || DEFAULT_MAIN_TAXON))
  ]);

  getMenuTree = memoizeOne(menu => (menu && !!menu.length) && taxonNestedSet.nest(menu));

  constructor(props) {
    super(props);

    this._howRef = React.createRef();
  }

  componentDidMount() {
    const {dispatch, taxon} = this.props;

    if (taxon) {
      dispatch(setUiMenuTaxon(taxon.slug));
      dispatch(setUiBreadcrumbs([taxon]));
    }

    MainPage.fetchData(this.props);
  }

  componentDidUpdate(prevProps) {
    const {dispatch, taxon} = this.props;

    if (taxon && taxon !== prevProps.taxon) {
      dispatch(setUiMenuTaxon(taxon.slug));
      dispatch(setUiBreadcrumbs([taxon]));
    }

    MainPage.fetchData(this.props);
  }

  render() {
    const {collapsed, mainTaxons, taxon, menu, products, showcase, params} = this.props;

    const menuTree = this.getMenuTree(menu);

    if (taxon === false) {
      return <ErrorPage/>;
    }

    if (!mainTaxons) {
      return <Loader page/>;
    }

    return (
      <div>
        {!params.mainTaxonSlug && (
          <JSONLDWebsite
            name="PrimeCarry"
            url={process.env.PUBLIC_URL}
          />
        )}

        <Hero>
          {!collapsed && (
            <Button onClick={() => animateScrollTo(this._howRef.current)}>
              How it works
            </Button>
          )}
        </Hero>

        {!mainTaxons ? (
          <Loader page/>
        ) : (
          <Content>
            <div className={styles.taxonToggle}>
              <div className={styles.taxonToggle_content}>
                <Toggle
                  leftLabel={mainTaxons[0].name}
                  rightLabel={mainTaxons[1].name}
                  isToggled={mainTaxons[1].slug === params.mainTaxonSlug}
                  onToggle={isToggled => browserHistory.push({pathname: `/${isToggled ? mainTaxons[1].slug : ''}`, state: {scroll: false}})}
                />
              </div>
            </div>

            <Services
              currentTaxon={taxon}
              menuTree={menuTree}
              showcase={showcase}
              products={products}
            />
          </Content>
        )}

        <div ref={this._howRef}/>

        <How/>

        <Reviews title="Why Choose Us?"/>

        <Advantages/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/mainPage/MainPage.js